import React, { useContext } from 'react'
import packageJson from "../../package.json";
import useAppContext from '../context/useAppContext';

export function getBaseUrl() {
  // @NOTE: (package.json "proxy" içinde configure edildi, eğer localde proxy kullanılmıcaksai package.jsondan "proxy" alanı silinebilir.)
  return process.env.NODE_ENV === "development" 
    ? packageJson.proxy ? "/webapi/Default.aspx?" : "http://localhost:90/webapi/Default.aspx?"
    : "/webapi/Default.aspx?";
}

export const URL = getBaseUrl();



const useRequest = () => {
    const [response, setResponse] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

      const {
        token
      } = useAppContext();

    let isSubscribed = true
    const startFetch = (params, method, body, contentType, callback) => {
      setLoading(true)
        fetch(URL + params, {
            method: method,
            headers: {
                'Content-Type': contentType || 'application/json; charset=UTF-8',
                "Authorization": token
            },
            body
        }).then(res => {
            if (isSubscribed) {
                if (res.ok) {
                    return res.json()
                }
            }
        }).then((data) => {
            if (isSubscribed) {
                if (data.errNo === -4) {
                    window.location.replace("/")
                }

                // special case for under age 18
                if(data.errNo === -30) {
                    callback(data)
                }

                // special case for ohter different errors such as repeated sms request or etc
                if(data.errNo === -50 || data.errNo === -51 || data.errNo === -52 || data.errNo === -53 || data.errNo === -54) {
                    callback(data)
                }

                // special case for iban verify when iban is wrong
                if(data.errNo === -16) {
                    callback(data)
                }

                // special case for person family and other information verify
                if(data.errNo === -62 || data.errNo === -61 || data.errNo === -60 || data.errNo === -59) {
                    callback(data)
                }

                setResponse(data)
                setLoading(false)

                if(data.errNo === 0 || data.Step) {
                    callback(data)
                }
            }
        }).catch((error) => {
            if (isSubscribed) {
                setError(error)
                setLoading(false)

            }
        })
        return () => {
            isSubscribed = false
        }
    }
    const fetchAdress = (params, method, callback) => {
        setLoading(true)
        fetch(`${"/adres"}${params}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                // "Authorization": token
            }
        }).then(res => {
            if (isSubscribed) {
                if (res.ok) {
                    return res.json()
                }
            }
        }).then((data) => {
            if (isSubscribed) {

                if (data.errNo === -4) {
                    window.location.replace("/")
                }

                // special case for address verify when address is wrong
                if (data.DurumKod == false) {
                    if(callback) {
                        callback(data)
                    }
                }
            
                const path = params.substring(
                    params.startsWith("/"),
                    params.lastIndexOf("/")
                );
                setResponse({ ...data, path: path })
                setLoading(false)
                if (callback) {
                    callback(data)
                }
            }
        }).catch((error) => {
            if (isSubscribed) {
                setError(error)
                setLoading(false)
            }
        })
        return () => isSubscribed = false
    }

    const ImageUpload = (params, file, callback) => {
        setLoading(true)
        fetch(URL + params, {
            method: "POST",
            headers: {
                "Content-Type": file.type,
                "Authorization": token
            },
            body: file
        }).then(res => {
            if (isSubscribed) {
                if (res.ok) {
                    return res.json()
                } else {
                    alert("Dosya yüklenemedi!")
                }
            }
        }).then((data) => {
            if (isSubscribed) {
                if (data.errNo === -4) {
                    window.location.replace("/")
                }
                if (data.errNo === -5) {
                    window.location.replace("/")
                }
                setResponse(data)
                setLoading(false)
                callback(data)
            }
        }).catch((error) => {
            if (isSubscribed) {
                setError(error)
                setLoading(false)

            }
        })
        return () => isSubscribed = false
    }

    const startFetchFormData = (endpoint, data, options = {}, callback) => {
      const { queryParams = {}, useSetter = true } = options;

      setLoading(true);
      let url = URL;
      let body = null;
      let headers = {
        Authorization: token,
      };

      const cleanURL = URL.endsWith("?") ? URL.slice(0, -1) : URL;
      const cleanEndpoint = endpoint.startsWith("?")
        ? endpoint.slice(1)
        : endpoint;

      if (Object.keys(queryParams).length > 0) {
        const queryString = new URLSearchParams(queryParams).toString();
        url = `${cleanURL}?${cleanEndpoint}&${queryString}`;
      } else {
        url = `${cleanURL}?${cleanEndpoint}`;
      }

      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
      body = formData;

      fetch(url, {
        method: "POST",
        headers: headers,
        body: body,
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          }
        })
        .then((data) => {
            if (data.errNo === -4) {
              window.location.replace("/");
              return;
            }
            callback(data);
            if(useSetter) {
              setResponse({...data, __endpoint: endpoint});
            }
            setLoading(false);
        })
        .catch((error) => {
          setError(error);
          setLoading(false);
        });
    };

    const ImageUploadFormData = (endpoint, file, options = {}, callback) => {
      const { queryParams = {}, additionalData = {} } = options;

      setLoading(true);
      let url = URL;
      let body = null;
      let headers = {
        Authorization: token,
      };

      // Query parametrelerini URL'e ekle
      const allQueryParams = { ...queryParams };
      if (endpoint.includes("=")) {
        const [key, value] = endpoint.split("=");
        allQueryParams[key] = value;
      }

      if (Object.keys(allQueryParams).length > 0) {
        const queryString = new URLSearchParams(allQueryParams).toString();
        url = `${URL}${queryString}`;
      } else {
        url = URL;
      }

      // FormData oluştur
      const formData = new FormData();

      // Dosyayı FormData'ya ekle
      if (file instanceof File) {
        formData.append("file", file);
      } else if (Array.isArray(file)) {
        // Çoklu dosya yükleme desteği
        file.forEach((f, index) => {
          formData.append(`file${index}`, f);
        });
      }

      // Ek verileri FormData'ya ekle
      Object.keys(additionalData).forEach((key) => {
        formData.append(key, additionalData[key]);
      });

      body = formData;

      fetch(url, {
        method: "POST",
        headers: headers,
        body: body,
      })
        .then((res) => {
          if (isSubscribed) {
            if (res.ok) {
              return res.json();
            } else {
              throw new Error("Dosya yüklenemedi!");
            }
          }
        })
        .then((data) => {
          if (isSubscribed) {
            if (data.errNo === -4) {
              window.location.replace("/");
            }

            setResponse(data);
            setLoading(false);

            if (callback) {
              callback(data);
            }
          }
        })
        .catch((error) => {
          if (isSubscribed) {
            setError(error);
            setLoading(false);
          }
        });

      return () => {
        isSubscribed = false;
      };
    };

    const customFetchFormData = (
      endpoint,
      data,
      options = {},
      onSuccess,
      onError,
    ) => {
      const { queryParams = {} } = options;

      let url = URL;
      let body = null;
      let headers = {
        Authorization: token,
      };

      const cleanURL = URL.endsWith("?") ? URL.slice(0, -1) : URL;
      const cleanEndpoint = endpoint.startsWith("?")
        ? endpoint.slice(1)
        : endpoint;

      if (Object.keys(queryParams).length > 0) {
        const queryString = new URLSearchParams(queryParams).toString();
        url = `${cleanURL}?${cleanEndpoint}&${queryString}`;
      } else {
        url = `${cleanURL}?${cleanEndpoint}`;
      }

      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
      body = formData;

      fetch(url, {
        method: "POST",
        headers: headers,
        body: body,
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          }
        })
        .then((data) => {
          if (data.errNo === -4) {
            //window.location.replace("/")
          } else if (data.errNo === 0 || data.Step) {
            onSuccess(data);
          } else if (data.Status) {
            onSuccess(data);

            // special case for time information
          } else if (data.Time !== "" && data.Time !== undefined) {
            onSuccess(data);
          } else {
            if (onError) {
              onError(data);
            }
          }
        })
        .catch((err) => {
          if (onError) {
            onError(err);
          }
        });
    };

    return {
      response,
      error,
      loading,
      startFetch,
      startFetchFormData,
      fetchAdress,
      ImageUpload,
      ImageUploadFormData,
      customFetchFormData,
      URL,
    };
}

export default useRequest
